import { Table } from "antd";
import { useTranslation } from "react-i18next";
import { BeaconSensorEvent } from "../../../api";
import { PagedApiState } from "../../../api/useApiState";
import { toAntdPagination } from "../../../util";
import { formatLocalizedDateTime } from "../../../util/formatting";

interface AccelerometerTableProps {
  sensorData: PagedApiState<BeaconSensorEvent>;
  axisPercision?: number;
  axisColumnWidth?: number;
}

export function AccelerometerTable({
  sensorData,
  axisPercision = 6,
  axisColumnWidth,
}: AccelerometerTableProps) {
  const { t } = useTranslation();

  const columns = [
    {
      key: "ts",
      title: t("timestamp"),
      render: (e: BeaconSensorEvent) => formatLocalizedDateTime(e.ts),
    },
    {
      key: "x",
      width: axisColumnWidth,
      title: t("accelerometer-x"),
      render: (e: BeaconSensorEvent) =>
        e.sensors?.accel?.x.toFixed(axisPercision),
    },
    {
      key: "y",
      width: axisColumnWidth,
      title: t("accelerometer-y"),
      render: (e: BeaconSensorEvent) =>
        e.sensors?.accel?.y.toFixed(axisPercision),
    },
    {
      key: "z",
      width: axisColumnWidth,
      title: t("accelerometer-z"),
      render: (e: BeaconSensorEvent) =>
        e.sensors?.accel?.z.toFixed(axisPercision),
    },
  ];

  return (
    <Table
      sticky
      style={{ gridColumn: "1 / -1" }}
      dataSource={sensorData.value?.items || []}
      rowKey={(record) =>
        `${record.ts}-${record.sensors?.accel?.x}-${record.sensors?.accel?.y}-${record.sensors?.accel?.z}`
      }
      size="middle"
      loading={sensorData.loading}
      columns={columns}
      pagination={toAntdPagination(sensorData, false)}
    ></Table>
  );
}
